import { render, staticRenderFns } from "./ui-update-info.vue?vue&type=template&id=77d32fd2&scoped=true&"
import script from "./ui-update-info.vue?vue&type=script&lang=ts&"
export * from "./ui-update-info.vue?vue&type=script&lang=ts&"
import style0 from "./ui-update-info.vue?vue&type=style&index=0&id=77d32fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d32fd2",
  null
  
)

export default component.exports